export const getOptions = () => ([
  {
    value: 1,
    label: '启用',
  },
  {
    value: 2,
    label: '禁用',
  },
]);

export default {
  getOptions,
  placeholder: '请选择状态'
}
